module.exports = __webpack_public_path__ + "media/character-fish-sad.2a6777fe.mp3";